"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var dealersListContainerStyles_1 = require("./dealersListContainerStyles");
var core_1 = require("@material-ui/core");
var DealerListHeader_1 = require("../dealerListHeader/DealerListHeader");
var DealersList_1 = require("../dealersList/DealersList");
var DealersListContainer = function (_a) {
    var dealers = _a.dealers, selectedDealerId = _a.selectedDealerId, selectDealerId = _a.selectDealerId, disableDealerSelection = _a.disableDealerSelection;
    var styles = dealersListContainerStyles_1.default();
    return (<core_1.Box className={styles.listContainer} data-test="container:dealerList">
      <DealerListHeader_1.default />
      <DealersList_1.default dealers={dealers} selectedDealerId={selectedDealerId} selectDealerId={selectDealerId} disableDealerSelection={disableDealerSelection}/>
    </core_1.Box>);
};
exports.default = DealersListContainer;
